import React, {Component} from 'react';
import { Dialog, DialogHeader, DialogBody, DialogFooter } from '../../../../presentation/Dialog';
import Overlay from '../../../../presentation/Overlay';
import { ProgramTabContainer, ProgramTabPanel, ProgramTabPanelItem } from '../../../../presentation/ProgramTabContainer';
import LeadGenSettings from './LeadGenSettings';
import LeadGenNumbersInGroup from './LeadGenNumbersInGroup';
import LeadGenOnNet from './LeadGenOnNet';
import LeadGenOffNet from './LeadGenOffNet';
// import LeadGenFileUploadHistory from './LeadGenFileUploadHistory';
import LeadGenChangeHistory from './LeadGenChangeHistory';
//import LeadGenDistribution from './LeadGenDistribution';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { clearUserProfile } from '../../../../redux/actions/user';
import { clearBugsnagUser } from '../../../../redux/actions/bugsnag';
import Alerts from '../../../../prototypes/Alerts';
import EtelAPI from '../../../../api/EtelAPI';

class LeadGenDialog extends Component {
  constructor( props ) {
    super( props );
    this.title = 'LeadGen Definition';
    this.state = {
      layout: props.layout === undefined ? {} : props.layout,
      show: props.show === undefined ? false : props.show,
      row: props.row === undefined ? {} : props.row,
      activeKey: 0
    };

    this.onClose = this.onClose.bind( this );
    this.onSave = this.onSave.bind( this );
    this.onChangeTab = this.onChangeTab.bind ( this );

    // Tab Section Events
    this.onChangeLeadGen = this.onChangeLeadGen.bind( this );
    this.onRowChanged = this.onRowChanged.bind( this );
  }

  componentWillReceiveProps( nextProps ) {
    this.setState( {
      layout: nextProps.layout === undefined ? {} : nextProps.layout,
      show: nextProps.show === undefined ? false : nextProps.show,
      row: nextProps.row === undefined ? {} : nextProps.row,
    } );
  }

  doLogOff( ) {
    const { dispatch } = this.props;
    const auth = this.props.auth;
    const history = this.props.history;
    auth.logout();
    dispatch( clearBugsnagUser() );
    dispatch( clearUserProfile() );
    history.push( '/login' );
  }

  onHandleException( e ) {
    const bugsnag = this.props.bugsnag;
    const { dispatch } = this.props;
    const alerts = new Alerts( bugsnag, dispatch );
    const status = e.status === undefined ? 0 : e.status;
    if( status === 401 ) {
      alerts.INFO( this.title, 'Your session has expired.' , 5000 );
      this.doLogOff();
    } else if( status === 500 ) {
      alerts.INFO( this.title, e.statusText , 5000 );
    } else {
      if( e.statusText !== undefined ) {
        alerts.CRITICAL( this.title, e, false );
      } else {
        alerts.CRITICAL( this.title, e );
      }
    }
  }

  onClose( e ) {
    if( this.props.onClose !== undefined ) {
      this.props.onClose( e );
    }
  }

  onSave( e ) {
    let { bugsnag, dispatch } = this.props;
    let alert = new Alerts( bugsnag, dispatch );
    let api = new EtelAPI( 'leadgen' );
    if( this.props.onSave !== undefined ) {
      const payload = this.getPayload( this.state.row );
      api.update( payload ).then ( ( result ) => { 
        let args = {
          target: {
            row: result.data[0]
          }
        };
        this.props.onSave( args );
        alert.SUCCESS( this.title, 'Successfully saved ' + this.title + '.', 2500 );
      } ).catch( ( exception ) => { 
        this.onHandleException( exception );
      } );
    }
  }

  onChangeTab( key, content ) {
    this.setState( {
      activeKey: parseInt( key, 10 )
    } );
  }

  onChangeLeadGen( row ) {
    this.setState( { 
      row: row
    } );
  }

  onRowChanged( row ) {
    this.setState( { 
      row: row
    } );
  }

  getPayload( row ) {

    if( row.CHK_ON === 'No' || row.CHK_ON === 'False' || row.CHK_ON === false ) {
      row.CHK_ON = 0;
    }

    if( row.CHK_ON === 'Yes' || row.CHK_ON === 'True' || row.CHK_ON === true ) {
      row.CHK_ON = 1;
    }

    if( row.CHK_OFF === 'No' || row.CHK_OFF === 'False' || row.CHK_OFF === false ) {
      row.CHK_OFF = 0;
    }

    if( row.CHK_OFF === 'Yes' || row.CHK_OFF === 'True' || row.CHK_OFF === true ) {
      row.CHK_OFF = 1;
    }

    if( row.ACTIVE === 'No' || row.ACTIVE === 'False' || row.ACTIVE === false ) {
      row.ACTIVE = 0;
    }

    if( row.ACTIVE === 'Yes' || row.ACTIVE === 'True' || row.ACTIVE === true ) {
      row.ACTIVE = 1;
    }

    let payload = {
      LEADGEN_DEF_ID: row.LEADGEN_DEF_ID,
      GROUP_NAME: row.GROUP_NAME,
      DEFDNIS: row.DEFDNIS,
      DESCRIPTION:  row.DESCRIPTION,
      BEGINDATE: row.BEGINDATE,
      ENDDATE: row.ENDDATE,
      CHK_ON: row.CHK_ON,
      CHK_OFF: row.CHK_OFF,
      ACTIVE: row.ACTIVE,
      CONTROL_RULES_APPLY: row.CONTROL_RULES_APPLY
    };

    return payload;
  }

  onRenderHeader( activeKey, row ) {
    let caption = this.title;
    if( activeKey === 0 ) {
      caption = 'Edit ' + this.title + ' - ' + row[ 'DEFDNIS' ] + ' ' + row[ 'GROUP_NAME' ];
    } else if( activeKey === 1 ) {
      caption = 'Numbers in Group - ' + row[ 'DEFDNIS' ] + ' (' + row[ 'GROUP_NAME' ] + ')';
    } else if( activeKey === 2 ) {
      caption = 'On Net - ' + row[ 'DEFDNIS' ] + ' (' + row[ 'GROUP_NAME' ] + ')';
    } else if( activeKey === 3 ) {
      caption = 'Off Net - ' + row[ 'DEFDNIS' ] + ' (' + row[ 'GROUP_NAME' ] + ')';
    } else if( activeKey === 4 ) {
      caption = 'File Upload History - ' + row[ 'DEFDNIS' ] + ' (' + row[ 'GROUP_NAME' ] + ')';
    } else if( activeKey === 5 ) {
      caption = 'Change History - ' + row[ 'DEFDNIS' ] + ' (' + row[ 'GROUP_NAME' ] + ')';
    } else if( activeKey === 6 ) {
      caption = 'Distribution - ' + row[ 'DEFDNIS' ] + ' (' + row[ 'GROUP_NAME' ] + ')';
    } 
    return caption;
  }

  onRenderBody( activeKey, row ) {
    let checkOnNetVisible = row.CHK_ON === 0 ? false : true;
    let checkOffNetVisible = row.CHK_OFF === 0 ? false : true;

    return (
      <ProgramTabContainer onSelectTab={this.onChangeTab} activekey={activeKey}>
        <ProgramTabPanel>
          <ProgramTabPanelItem caption="Settings" width="100px">
            <LeadGenSettings row={this.state.row} onRowChanged={this.onRowChanged} />
          </ProgramTabPanelItem>
          <ProgramTabPanelItem caption={'Numbers in Group'} width="175px">
            <LeadGenNumbersInGroup row={this.state.row} />
          </ProgramTabPanelItem>
          <ProgramTabPanelItem caption={'On Net'} width="100px" visible={checkOnNetVisible}>
            <LeadGenOnNet row={this.state.row} />
          </ProgramTabPanelItem>
          <ProgramTabPanelItem caption="Off Net" width="100px" visible={checkOffNetVisible}>
            <LeadGenOffNet row={this.state.row} />
          </ProgramTabPanelItem>
          <ProgramTabPanelItem caption="Change History" width="150px">
            <LeadGenChangeHistory row={this.state.row} />
          </ProgramTabPanelItem>
        </ProgramTabPanel>
      </ProgramTabContainer>
    );
  }

  onRenderFooter( activeKey, row ) {
    let renderedFooter = []; 
    if( activeKey === 0 ) {
      
      renderedFooter.push( 
        <button key="dialog-cancel-button" className="dialog-cancel-button" onClick={this.onClose}>
          Cancel
        </button>
      );

      renderedFooter.push( 
        <button key="dialog-save-button" className="dialog-save-button" onClick={this.onSave}>
          Save
        </button>
      );

    } else {
      renderedFooter.push( 
        <button key="dialog-cancel-button" className="dialog-cancel-button" onClick={this.onClose}>
          Cancel
        </button>
      );
    }
    return renderedFooter;
  }

  render() {
    const activeKey = parseInt( this.state.activeKey, 10 );
    const row = this.state.row;
    let caption = this.onRenderHeader( activeKey, row );
    return (
      <div>
        <Overlay show={this.state.show} />
        <Dialog show={this.state.show} width={90} height={90}>
          <DialogHeader caption={caption} closeButton onClose={this.onClose} />
          <DialogBody>
            {this.onRenderBody( activeKey, row )}
          </DialogBody>
          <DialogFooter>
            { this.onRenderFooter( activeKey, row ) }
          </DialogFooter>
        </Dialog>
      </div>
    );
  }
}

export default withRouter(
  connect(
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user
      };
    }
  )( LeadGenDialog ) );


// WEBPACK FOOTER //
// ./src/content/enterprise/leadgen/components/LeadGenDialog.js